var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcons2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5858 3.21742L14.1991 6.44409C14.4191 6.89325 15.0058 7.32409 15.5008 7.40659L18.4249 7.89242C20.2949 8.20409 20.7349 9.56075 19.3874 10.8991L17.1141 13.1724C16.7291 13.5574 16.5182 14.2999 16.6374 14.8316L17.2883 17.6458C17.8016 19.8733 16.6191 20.7349 14.6483 19.5708L11.9074 17.9483C11.4124 17.6549 10.5966 17.6549 10.0924 17.9483L7.35158 19.5708C5.38992 20.7349 4.19825 19.8641 4.71158 17.6458L5.36242 14.8316C5.48158 14.2999 5.27075 13.5574 4.88575 13.1724L2.61242 10.8991C1.27408 9.56075 1.70492 8.20409 3.57492 7.89242L6.49908 7.40659C6.98492 7.32409 7.57158 6.89325 7.79158 6.44409L9.40492 3.21742C10.2849 1.46659 11.7149 1.46659 12.5858 3.21742Z",
    stroke: "#15194B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcons2);
export default __webpack_public_path__ + "static/media/menu-icons-2.598543f1d48f439a1c7fc350d6ab0b50.svg";
export { ForwardRef as ReactComponent };